<template>
    <!-- 批量授权人员表单的数据权限 -->
    <div class="data-auth-batch-content">
        <!-- 人员数据容器 -->
        <div class="user-box">
            <div class="tree-type">
                <div class="type-item" @click="changeTreeType(1)" :class="{ active: treeType == 1 }">
                    单个
                </div>
                <div class="type-item"  @click="changeTreeType(2)" :class="{ active: treeType == 2 }">
                    批量
                </div>
            </div>
             <OrgUserTree @loadUserForms="loadUserForms" ref="orgUserTree" :showCheckbox="showCheckbox"></OrgUserTree>
        </div>
        <!-- 表单数据容器 -->
        <div class="form-box">
            <div class="table-search">
                <div class="choose-people" v-if="showCheckbox==false">当前人&nbsp;:&nbsp;<span class="choose-people-name">{{choosePeopleName}}</span></div>
                <el-input
                  placeholder="请输入应用名称"
                  v-model="searchAppName"
                  prefix-icon="el-icon-search"
                  class="item"
                  >
                </el-input>
                <el-input
                  placeholder="请输入功能模块"
                  v-model="searchFunctionName"
                  prefix-icon="el-icon-search"
                  class="item"
                  >
                </el-input>
                <el-input
                  placeholder="请输入模型名称"
                  v-model="searchModelName"
                  prefix-icon="el-icon-search"
                  class="item"
                  >
                </el-input>
                <el-button type="primary" icon="el-icon-search" @click="searchModel">搜索</el-button>
            </div>
            <div class="table-body">
                <el-table
                    :data="tableData"
                    @selection-change="handleSelectionApp"
                    border
                    >
                    <el-table-column
                      type="selection"
                      width="40">
                    </el-table-column>
                    <el-table-column
                      prop="appName"
                      label="所属应用"
                      :show-overflow-tooltip="true"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="functionName"
                      label="功能模块"
                      :show-overflow-tooltip="true"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="modelName"
                      :show-overflow-tooltip="true"
                      label="模型名称">
                    </el-table-column>
                    <el-table-column
                      prop="trueName"
                      :show-overflow-tooltip="true"
                      label="创建人">
                    </el-table-column>
                  </el-table>
            </div>
            <div class="table-page">
                <el-pagination
                  background
                  layout="total,sizes,prev, pager, next"
                  :page-size="page.pageSize"
                  :page-sizes="[5, 10, 20, 30, 1000]"
                   @current-change="handleCurrentChange"
                   @size-change="queryFormDataByPageSize"
                  :current-page.sync="page.currentPage"
                  :total="page.totalPageNum">
                </el-pagination>
            </div>

        </div>
        <!-- 部门数据容器 -->
        <div class="org-box">
 <!--           <div class="org-search">

            </div> -->
            <div class="org-body">
                <template>
                  <el-table
                    :data="orgTableData"
                    @selection-change="handleSelectionOrg"
                    height="60vh"
                    border>
                    <el-table-column
                      type="selection"
                      align="center"
                      width="40">
                    </el-table-column>

                    <el-table-column
                      prop="label"
                      :show-overflow-tooltip="true"
                      label="部门名称"
                     >
                    </el-table-column>
                    <el-table-column
                      label="详细权限"
                      width="90">

                       <template slot-scope="scope">
                          <el-select v-model="scope.row.operAuthIds" placeholder="请选择">
                                  <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                            </el-select>
                        </template>

                    </el-table-column>
                  </el-table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import OrgUserTree from '@/components/OrgUserTree/OrgUserTree';
    import {getUserForms, getOrgAuthList} from '@/data-model';
    export default{
        components: {
            OrgUserTree
        },
        data () {
            return {
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                modelsData: [],
                tableData: [],
                searchModelName: '',
                searchFunctionName: '',
                searchAppName: '',
                userId: '',
                choosePeopleName: '所有',
                orgTableData: [],
                options: [{
                    value: '0',
                    label: '查看'
                }, {
                    value: '2',
                    label: '修改'
                }, {
                    value: '3',
                    label: '删除'
                }, {
                    value: '2,3',
                    label: 'ALL'
                }],
                forms: [],
                orgs: [],
                treeType: 1,
                showCheckbox: false
            };
        },
        created () {
            this.initModels();
            this.initOrgList();
        },
        methods: {
            loadUserForms (obj) {
                if (this.treeType === 1) { // 单个
                    this.userId = obj.id;
                    this.choosePeopleName = obj.label;
                    this.initModels();
                } else { // 批量
                    let userids = [];
                    for (var i = 0; i < obj.length; i++) {
                        userids.push(obj[i].id);
                    }
                    this.userId = userids.join(',');
                    this.initModels();
                }
            },
            async initModels () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let params = {searchContent: this.searchContent,
                    page: this.page.currentPage,
                    pageCount: this.page.pageSize,
                    userId: this.userId,
                    searchModelName: this.searchModelName,
                    searchFunctionName: this.searchFunctionName,
                    searchAppName: this.searchAppName};
                let data = await getUserForms(params);
                if (data) {
                    this.page.totalPageNum = data.count;
                    this.tableData = data.userModels;
                }
                loading.close();
            },
            handleCurrentChange (val) {
                this.page.currentPage = val;
                this.initModels();
            },
            async initOrgList () {
                let param = {};
                let data = await getOrgAuthList(param);
                this.orgTableData = data;
            },
            handleSelectionOrg (rows) {
                this.orgs = rows;
            },
            handleSelectionApp (rows) {
                this.forms = rows;
            },
            buildParam () {
                let param = {};
                param.formId = JSON.stringify(this.forms);
                param.selectedOrgIds = JSON.stringify(this.orgs);
                param.users = this.userId;
                return param;
            },
            searchModel () {
                this.initModels();
            },
            changeTreeType (o) {
                this.treeType = o;
                this.userId = '';
                if (o === 1) {
                    this.showCheckbox = false;
                } else if (o === 2) {
                    this.showCheckbox = true;
                }
                this.initModels();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this.initModels();
            }
        }

    };
</script>

<style lang="less" scoped="scoped">
    .data-auth-batch-content{
        width: 100%;
        height: 70vh;
        display: flex;
        overflow: auto;
        .user-box{
           flex: 2;
           min-width: 180px;
           .tree-type{
               display: flex;
               .type-item{
                  flex: 1;
                  cursor: pointer;
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  background: #fff;
                  border: 1px solid #dcdfe6;

               }
               .active{
                   color: #fff;
                   background-color: #409eff;
                   border-color: #409eff;
               }
           }
           /deep/ .search-content{
               .el-input__inner{
                   border-radius: 0px;
                   border-top: none;
               }
           }
           // .tree-type:first-child{
           //   border-left: 1px solid #dcdfe6;
           //   border-radius: 4px 0 0 4px;

           // }
        }
        .form-box{
            flex: 4;
            padding-left: 10px;
            width: 38vw;
            overflow: auto;
            .table-search{
                display:flex;
                .item{
                    width: 160px;
                    margin-right: 10px;
                }
                .choose-people{
                    margin-right: 10px;
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    .choose-people-name{
                        width: 60px;
                        font-size: 18px;
                        color: red;
                        text-overflow:ellipsis;
                    }

                }
             }
            .table-body{
                margin-top: 4px;
                width: 100%;
                // .el-table th.gutter{
                // 		display: table-cell!important;
                // 	}

                // .has-gutter {
                //     .gutter {
                //         width: 0px !important;
                //         display: block;
                //     }
                // }
            }
            .table-page{
                margin-top: 10px;
            }
        }
        .org-box{
           flex: 2;
           // height:520px;
           overflow: auto;
           padding-left: 10px;
           min-width: 230px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataAuthBatch/DataAuthBatch.vue